'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _components2 = require('components');

var _pacomo = require('utils/pacomo');

var _forms = require('utils/forms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormErrorMessage = function FormErrorMessage(_ref) {
    var errorCode = _ref.errorCode,
        invalid = _ref.invalid,
        submitting = _ref.submitting,
        submitFailed = _ref.submitFailed,
        children = _ref.children;

    var contactPrompt = _react2.default.createElement(_components2.DynamicCommunication, { type: 'contactPrompt' });

    if (children) return _react2.default.createElement(
        'div',
        { className: 'alert alert--inline', role: 'alert' },
        _react2.default.createElement(
            'p',
            null,
            children
        )
    );

    if (errorCode && !submitting) {
        var errMsg = void 0;
        switch (errorCode) {
            case 'AUTH_FAILED':
                {
                    errMsg = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formMessages.errors.authFailedTitle',
                                defaultMessage: 'Verification Failed' })
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formMessages.errors.authFailedMsg',
                                defaultMessage: 'The nationality and date of birth combination entered do not match the customer on file for this booking. If you\'re sure your information is correct and you still cannot complete this verification step, please contact your travel agent.' })
                        )
                    );
                    break;
                }
            case 'MESSAGE_POST_FAILED':
                {
                    errMsg = _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formMessages.errors.msgFailed',
                            defaultMessage: 'Reminder email failed to send. Please ensure you entered in a valid email address, and if the problem persists, please {contactPrompt}.',
                            values: { contactPrompt: contactPrompt } })
                    );
                    break;
                }
            case 'INVALID_FLIGHT_SEGMENT':
                {
                    errMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formMessages.errors.invalidFlightSegment',
                        defaultMessage: 'Invalid flight segment. Please double-check the airline code, flight number, airport or date.' });
                    break;
                }
            case 'FLIGHT_SEGMENT_ZERO_SCHEDULES_RETURNED':
                {
                    errMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formMessages.errors.zeroSchedulesReturned',
                        defaultMessage: 'We want to ensure the flights you\'ve entered are correct. Please review the information you\'ve provided, and enter your arrival airport along with the arriving date and time.' });
                    break;
                }
            case 'FLIGHT_SEGMENT_NO_SCHEDULE_MATCH':
                {
                    errMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formMessages.errors.noScheduleMatch',
                        defaultMessage: 'We found some flights that do not exactly match your info. Please double check your input.' });
                    break;
                }
            case 'FLIGHT_SEGMENT_NOT_CREATED':
                {
                    errMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formMessages.errors.segmentNotCreated',
                        defaultMessage: 'We are not able to capture this flight. Please contact us by phone or email.' });
                    break;
                }
            case 'FLIGHT_STATUS_DUPLICATE_SEGMENT':
                {
                    errMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formMessages.errors.duplicateSegment',
                        defaultMessage: 'You\'ve entered in the same flight multiple times. Please ensure each flight is different.' });
                    break;
                }
            case "SEGMENT_DURATION_TOO_LONG":
                {
                    errMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formMessages.errors.segmentDurationTooLong',
                        defaultMessage: 'Your flight is longer than 18 hours. Please check the dates.'
                    });
                    break;
                }
            default:
                {
                    errMsg = errorCode !== 'DEFAULT' && /^[A-Z][A-Z0-9_]*$/.test(errorCode) ? (0, _forms.formServerValidationMsg)(null, errorCode) : _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formMessages.errors.somethingWentWrong',
                                defaultMessage: 'Uh Oh! Something went wrong...' })
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formMessages.errors.general',
                                defaultMessage: 'We were unable to submit your changes. Please {contactPrompt}',
                                values: { contactPrompt: contactPrompt } })
                        )
                    );
                }
        }
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { className: 'alert', role: 'alert' },
                errMsg
            )
        );
    } else if (!errorCode && invalid && !submitting && submitFailed) {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { className: 'alert', role: 'alert' },
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formMessages.errors.fixYourFields',
                        defaultMessage: 'Please fix the fields highlighted below and try again.' })
                )
            )
        );
    } else {
        return _react2.default.createElement('div', null);
    }
};
FormErrorMessage.propTypes = {
    errorCode: _propTypes2.default.string,
    submitting: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool
};

FormErrorMessage = (0, _pacomo.pacomoTransformer)(FormErrorMessage);

exports.default = FormErrorMessage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/FormErrorMessage.js
// module id = 306
// module chunks = 0